import { InjectionToken } from '@angular/core';

export const WINDOW_TOKEN = new InjectionToken<Window>(
  'Injection token for the window object.'
);
